import classNames from 'classnames/bind';
import styles from './v4Notice.module.scss';

const cx = classNames.bind(styles);

const V4Notice = () => {
  return (
    <p className={cx('noticeText')}>
      {`<내 영상 확인하기>`}는 응시자 스스로 영상을 확인하며 자신의 면접을 개선하는 것을 목적으로 하고 있어요!
      <br />
      일부 영상면접 과정에 대한 답변 영상을 제공 드리며, 답변 내용 자체는 분석되지 않아요!
    </p>
  );
};

export default V4Notice;
